<script setup lang="ts">
  import { ref, watch } from "vue";
  import { Image as ImageIcon } from "lucide-vue-next";

  const props = withDefaults(defineProps<{ src?: string | null; alt?: string; mediaType?: "image" | "video" }>(), {
    src: null,
    alt: "",
    mediaType: "image",
  });

  const failed = ref(false);
  watch(
    () => props.src,
    () => (failed.value = false),
  );
</script>

<template>
  <span class="grid size-10 shrink-0 place-items-center overflow-hidden rounded-md border bg-muted">
    <video
      v-if="props.src && !failed && props.mediaType === 'video'"
      :src="`${props.src}#t=0.1`"
      :aria-label="props.alt"
      class="size-full object-cover"
      muted
      preload="metadata"
      @error="failed = true" />
    <img
      v-else-if="props.src && !failed"
      :src="props.src"
      :alt="props.alt"
      class="size-full object-cover"
      loading="lazy"
      @error="failed = true" />
    <ImageIcon
      v-else
      class="size-4 text-foreground-subtle"
      :stroke-width="1.8" />
  </span>
</template>
